import { Component, OnInit, ViewChild, Inject, Output, EventEmitter } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { XAPILogComponent } from '@app/main/analytics/xapi-log/xapi-log.component';
import { fuseAnimations } from '@fuse/animations';
import { AssessmentResult, Course } from '@shared/models';
import { AssessmentService } from '@shared/services/assessment.service';


@Component({
  selector: 'program-reporting-session-log',
  templateUrl: './program-reporting-session-log.component.html',
  styleUrls: ['./program-reporting-session-log.component.scss'],
  animations: fuseAnimations
})

export class ProgramReportingSessionLogComponent implements OnInit {
  @Output() onExplore = new EventEmitter<{ assessmentResult: AssessmentResult, course: Course }>();
  public sessionId: string;
  public course: Course;
  public assessmentResult: AssessmentResult;
  public userName: string;
  public initials: string;
  public sessionDate: Date;
  public durationInMinutes: number;
  public messageCount: number;
  @ViewChild(XAPILogComponent) logsComponent: XAPILogComponent;

  constructor(
    private _assessmentService: AssessmentService,
    public _dialogRef: MatDialogRef<ProgramReportingSessionLogComponent>,
    private _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public _data: { sessionId:string, course: Course }
  ) {
    this.sessionId = _data.sessionId;
    this.course = _data.course;
  }

  async ngOnInit(): Promise<void> {
    this.assessmentResult = await this._assessmentService.getAssessmentBySessionId(this.sessionId).toPromise();
  }

  openAssessmentDashboard() {
    this.closeDialog();
    this.onExplore.emit({
      assessmentResult: this.assessmentResult,
      course: this.course
    });
  }

  onLogsLoaded(event: { logs: any[], userName: string }) {
    const timestamps = event.logs.map(log => new Date(log.date).getTime());
    const start = Math.min(...timestamps);
    const end = Math.max(...timestamps);
    this.userName = event.userName;
    this.initials = (event.userName || '')
      .split(/\s+/)
      .map(s => s.length ? s[0].toUpperCase() : '')
      .join('')
      .substring(0, 2);
    this.sessionDate = timestamps.length ? new Date(start) : null;
    this.durationInMinutes = timestamps.length ? Math.max(1, Math.round((end - start) / 60000)) : 0;
    this.messageCount = event.logs.length;
  }

  downloadLogs() {
    this.logsComponent?.exportStats();
  }

  closeDialog() {
    this._dialogRef.close();
  }
}
